import { useState } from "react"
import { BaseContainer } from "../../core/base_container"
import ChatGPTStore from "../../lazyLoaders/chat_gpt"
import { Col, Form, Row, Spinner } from "react-bootstrap"
import OpenAI from "openai"
import SessionStore from "../../lazyLoaders/session_lazy"
import { axiosBaseURL } from "../../http"
import { toast } from "react-toastify"
import './css/search.css'
export const Search = () => {
    const [aiReply, setAiReply] = useState('')
    const [searchTerm, setSearchTerm] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const handleSubmit = (e) => {
        e.preventDefault()
        if (!searchTerm || searchTerm.length <= 15) {
            toast.error('Your question must be 15 characters or more.')
            return
        }
        ChatGPTStore.getApiKey().then(function (key) {
            if (key) {
                setIsLoading(true)
                const client = new OpenAI({
                    apiKey: key,
                    dangerouslyAllowBrowser: true
                });
                client.chat.completions.create({
                    messages: [{
                        role: 'user',
                        content: `Answer kindly and clearly. The user is an exoneree, recently released and rebuilding their life. Respond in 5 sentences or less. Question: ${searchTerm}`
                    }],
                    model: 'gpt-4o-mini'
                }).then(function (response) {
                    setAiReply(getResponse(response));
                    saveSearch(searchTerm)
                    setSearchTerm('')
                }).catch(function (error) {
                    toast.error('ChatGPT is currently unavailable.')
                }).finally(() => {
                    setIsLoading(false)
                })
            }
        }).catch(function (error) {
            console.log(error)
            toast.error('Search is currently disabled.')
        })
    }

    const saveSearch = (searchQuery) => {
        const chapterID = SessionStore.getChapter()
        if (!chapterID)
            return;
        axiosBaseURL.post("search_term_api/search_term_hist/", { search_term: searchQuery, chapter_reltn: chapterID })
            .catch(function (error) {
                console.error('Failed to save search term')
                console.error(error)
            });
    }

    const getResponse = (response) => {
        let message = 'No readable message returned. Try again.'
        try {
            message = response.choices[0].message.content
            return message
        } catch (ex) {
            return message
        }
    }

    return (
        <BaseContainer min_height='25vh'>
            <Form onSubmit={handleSubmit} style={{ marginTop: '5rem', minHeight: "100vh" }}>
                <Form.Group className="mb-3">
                    <Form.Control
                        className="search-input"
                        maxLength={255}
                        type="text"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)} placeholder="Ask a question.."
                    />
                </Form.Group>
                <Form.Group className="content-slot" style={{ minHeight: "80px" }}>
                    {isLoading && (
                        <Row className="justify-content-center mt-3">
                            <Spinner animation="border" role="status" variant="success" />
                        </Row>
                    )}
                    {aiReply && !isLoading && (
                        <Row className="mt-3">
                            <Col>
                                <div className="p-3 shadow-sm">
                                    <p className="mb-1 fw-semibold text-dark">{aiReply}</p>
                                    <small className="text-muted">
                                        ChatGPT can make mistakes.
                                        <br />
                                        Check important info.
                                    </small>
                                </div>
                            </Col>
                            <p className="text-muted"></p>
                        </Row>
                    )}
                </Form.Group>
            </Form>
        </BaseContainer>
    )
}